import { IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class CreateClassSectionExternalRefDto {
  @ApiProperty({
    description: 'ID de la section (UUID v4)',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  id!: string

  @ApiProperty({ type: 'string', description: 'Code de la section', example: 'GENERALE' })
  @IsNotEmpty()
  @IsString()
  code!: string

  @ApiProperty({ type: 'string', description: 'Libellé de la section', example: 'Générale' })
  @IsNotEmpty()
  @IsString()
  label!: string

  @ApiPropertyOptional({ type: 'string', description: 'Description' })
  @IsOptional()
  @IsString()
  description?: string

  @ApiProperty({
    description: 'Parcours éducatifs (array)',
    example: ['LYCEE_GENERAL'],
    type: [String],
  })
  @IsNotEmpty()
  track!: string[]

  @ApiPropertyOptional({
    description: 'Codes des niveaux compatibles',
    example: ['2DE', '1RE', 'TLE'],
    type: [String],
  })
  @IsOptional()
  validLevelCodes?: string[]

  @ApiPropertyOptional({
    description: 'Codes des diplômes compatibles',
    example: ['BAC_GENERAL'],
    type: [String],
  })
  @IsOptional()
  validDegreeTypes?: string[]
}
